export default __webpack_public_path__ + "static/media/icon_no_realizado_fail.80242182.svg";